import {AnnotationsReaderBase} from './AnnotationsReaderBase';
import {AnnotationsReader} from './AnnotationsReader';
import {createHelper} from './annotations-reader-helper';

export const createAnnotationsReader = (annotationsServiceLocator) => {
  // Need a service locator to export annotations.
  if (!annotationsServiceLocator) {
    return new AnnotationsReaderBase();
  }

  const helper = createHelper(annotationsServiceLocator);

  const canvas = document.createElement('canvas');
  // Test if browser does not use non-standards msToBlob, which throws a security error exporting svg data from canvas
  if (canvas.toBlob) {
    return new AnnotationsReader(helper);
  } else {
    return new AnnotationsReaderBase();
  }
};
